import { useEffect, useState, useRef, useContext } from 'react'
import { HubConnectionBuilder } from '@microsoft/signalr';
import { AppContext } from '../../context/AppContext';

const RefreshNotifications = ({setRefresh}) => {

    const [ connection, setConnection ] = useState(null);
    const [ message, setMessage ] = useState(null);
    const dataFetchedRef = useRef(false);

    const {SiteConfig} = useContext(AppContext);

    useEffect(()=>{

        // if (dataFetchedRef.current) return;
        // dataFetchedRef.current = true;

        const newConnection = new HubConnectionBuilder()
        //.withUrl( SiteConfig.API_NOTIFICATION_HUB_URL + 'notifications')
        .withUrl( SiteConfig.API_NOTIFICATION_HUB_URL)
        .withAutomaticReconnect()
        .build();

        setConnection(newConnection);

    },[]);


    useEffect(()=>{

        if(connection){
            connection.start()
            .then(result => {
               // console.log("connected");

                const sNotificationMethodName = "RefreshMessage" + SiteConfig.CURRENT_USER_TENANT_ID;    

                //connection.on("ReceiveMessage", message =>{
                connection.on(sNotificationMethodName, message =>{
                    setMessage(message);
                    //setNotifications(prevNotifications=> [...prevNotifications, {smessage:message}]);                    
                    setRefresh(prevRefreshData => prevRefreshData +1);
                }
                
                )
            })
            .catch(e=> console.log("connection failed : ",e ) )
        }

    },[]);

//   return (
//     <>
//     <div>Notifications :{message}</div>
//     <Button onClick={()=>handleclick("message from client")}>TEST</Button>
//     </>
//   )
}

export default RefreshNotifications